import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchAccountDetails } from '../actions/account.js'
import './Home.css';

export class Home extends Component {
    static propTypes = {
        prop: PropTypes
    }

    componentDidMount() {
      const {dispatch} = this.props
      let account = this.props.account
      if (account.status == "active") {
        dispatch(fetchAccountDetails(account._id))
      }
    }

    render() {
        let account = this.props.account
        let building = account.buildings[0]
        let buildingName = "420 Lex";
        
        if (account.activeBuilding) {
          buildingName = account.activeBuilding.name;
        } else if (account.buildings && account.buildings.length > 0) {
            buildingName = account.buildings[0].name
        }

        return (
            <div>
                <div className="container">
                    <div className="row circles-row">
                        <div className="col-md-3 col-sm-3 col-xs-6"><a href="/events/upcoming"><div className="circle do"></div><span className="icon-text">Do</span></a></div>
                        <div className="col-md-3 col-sm-3 col-xs-6"><a href="/BuildingControls/"><div className="circle control"></div><span className="icon-text"> Control </span></a></div>
                        <div className="col-md-3 col-sm-3 col-xs-6"><a href="/locations/bookings"><div className="circle reserve"></div><span className="icon-text">Book </span></a></div>
                        <div className="col-md-3 col-sm-3 col-xs-6"><a href="/BuildingDetails"><div className="circle building"></div><span className="icon-text"> {buildingName} </span></a></div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return { account: state.authReducer.account }
}

export default connect(mapStateToProps)(Home)



// WEBPACK FOOTER //
// ./src/components/Home.js